<template>
  <div class="results-component py-[50px] rounded-[12px]" v-if="allSearchData && allSearchData.length > 0">
    <div class="bg-[#FFFFFF] min-w-[500px] max-w-[90%] mx-auto p-[20px] rounded-[12px]">
      <div v-if="type === uiTypes.account" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Accounts' : 'Account' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllAccountsList :accounts="{items: allSearchData}" />
        </div>
      </div>

      <div v-if="type === uiTypes.block" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Blocks' : 'Block' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllBlocksList :blocks="{items: allSearchData}" />  
        </div>
      </div>

      <div v-if="type === uiTypes.transaction" class="mb-[10px ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Transactions' : 'Transaction' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllTransactionsList :transactions="{items: allSearchData}" />
        </div>
      </div>
      <div v-if="type === uiTypes.token" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Tokens' : 'Token' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllTokensList :tokens="{items: allSearchData}" />
        </div>       
      </div>       
      <div v-if="type === uiTypes.asset" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Assets' : 'Asset' }}
            &#x2022;
            {{ allSearchData.length }}
          </h2>
          <AllAssetsList :assets="{items: allSearchData}" />
        </div>
      </div>
      <div v-if="type === uiTypes.nft" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'NFTs' : 'NFT' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllNFTsList :nfts="{items: allSearchData}" />
        </div>       
      </div>       
      <div v-if="type === uiTypes.chain" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Chains' : 'Chain' }} 
            &#x2022; 
            {{ allSearchData.length }}
          </h2>
          <AllChainsList :chains="{items: allSearchData}" />
        </div>       
      </div>
      <div v-if="type === uiTypes.meta" class="mb-[10px  ]">
        <div>
          <h2 class="text-2xl font-bold mb-4 text-blue-light">
            {{ allSearchData.length > 1 ? 'Metadatas' : 'Metadata' }}
            &#x2022;
            {{ allSearchData.length }}
          </h2>
          <AllMetadatasList :metadatas="{items: allSearchData}" />
        </div>
      </div>
    </div>
    
    <!-- Loading indicator for infinite scroll -->
    <div v-if="loading" class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-light"></div>
    </div>
    
    <!-- End of results indicator -->
    <!-- <div v-if="!hasMoreData && allSearchData.length > 0" class="text-center py-8 text-gray-500">
      <p>No more results to load</p>
    </div> -->
  </div>
</template>

<script>
import api from '@/helpers/api';
import AllTransactionsList from '@/components/common/AllTransactionsList.vue';
import AllBlocksList from '@/components/common/AllBlocksList.vue';
import AllAccountsList from '@/components/common/AllAccountsList.vue';
import AllTokensList from '@/components/common/AllTokensList.vue';
import AllAssetsList from '@/components/common/AllAssetsList.vue';
import AllNFTsList from '@/components/common/AllNFTsList.vue';
import AllMetadatasList from '@/components/common/AllMetadatasList.vue';
import AllChainsList from '@/components/common/AllChainsList.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: "AllResultsComponent",
  components: {
    AllTransactionsList,
    AllBlocksList,
    AllAccountsList,
    AllTokensList,
    AllAssetsList,
    AllNFTsList,
    AllMetadatasList,
    AllChainsList,
  },
  props: {
    // Define props here if needed
  },
  data() {
    return {
      uiTypes: UiTypes,
      loading: false,
      hasMoreData: true,
      currentOffset: 0,
      limit: 10,
      allSearchData: [],
    };
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    searchQuery() {
      return this.$route.query.value || '';
    },
    filteredSearchData() {
      // Filter search data to show only the specified type
      if (this.type && this.allSearchData.length > 0) {
        return this.allSearchData.filter(item => item.type === this.type);
      }
      return this.allSearchData;
    },
  },
  created() {
    // Lifecycle hook for when the component is created
    this.fetchData();
  },
  mounted() {
    // Add scroll event listener for infinite scroll
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    // Remove scroll event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    fetchData(loadMore = false) {
      if (this.loading) return;
      
      this.loading = true;
      const offset = loadMore ? this.currentOffset : 0;
      
      // Search for all types or specific type based on route params
      const searchQuery = this.searchQuery;
      const searchType = this.type || 'all';
      
      api.searchBlockchainBySearchType(searchType, searchQuery, this.limit, offset)
        .then(response => {
          console.log("Search results:", response.data);
          const res = response.data;

          if (res.result && res.result.items && res.result.items.length > 0) {
            if (loadMore) {
              // Append new data to existing data for infinite scroll
              this.allSearchData = [...this.allSearchData, ...res.result.items];
            } else {
              // Initial load - replace all data
              this.allSearchData = res.result.items;
            }
            
            this.currentOffset += this.limit;

            console.log("Current offset after fetch:", this.currentOffset, res.result.total);
            
            // Check if there's more data to load
            this.hasMoreData = res.result && res.result.total.value > this.currentOffset;
            this.loading = !!(this.hasMoreData);
          } else {
            this.hasMoreData = false;
          }
        })
        .catch(error => {
          console.error("Error fetching search data:", error);
          this.hasMoreData = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1500);
        });
    },
    mergeSearchData(newData) {
      // Merge new data with existing data by type
      newData.forEach(newSearchList => {
        const existingIndex = this.allSearchData.findIndex(
          existing => existing.type === newSearchList.type
        );
        
        if (existingIndex !== -1) {
          // Merge items for existing type
          this.allSearchData[existingIndex].items.push(...newSearchList.items);
          // Update total information
          if (newSearchList.total) {
            this.allSearchData[existingIndex].total = newSearchList.total;
          }
        } else {
          // Add new search type
          this.allSearchData.push(newSearchList);
        }
      });
    },
    handleScroll() {
      // Check if user has scrolled near the bottom
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Load more data when user is within 200px of the bottom
      if (scrollTop + windowHeight >= documentHeight - 200) {
        if (this.hasMoreData && !this.loading) {
          this.fetchData(true);
        }
      }
    },
    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const dateOptions = { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      };
      const timeOptions = { 
        hour: 'numeric', 
        minute: '2-digit', 
        second: '2-digit',
        hour12: true 
      };
      
      const formattedDate = date.toLocaleDateString('en-US', dateOptions);
      const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      
      return `${formattedDate}, ${formattedTime}`;
    },
    truncateAddress(address) {
      if (!address || address === 'N/A') {
        return address;
      }
      
      if (address.length <= 10) {
        return address;
      }
      
      // Show first 4 and last 5 characters without ellipsis
      const start = address.slice(0, 6);
      const end = address.slice(-5);
      return `${start}...${end}`;
    },
  
  },
};
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>